import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../../css/pages.css';
import language from '../../utils/LanguageSettings';
import { fetchLegalComplianceInformation } from '../functions/fetchLegalComplianceInformation';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import RenderSnA from '../functions/renderSnA';

const Sitemap: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [content,setContent] = useState<any>();
  const [seo, setSeo] = useState<any>(null);
  const [ga, setGa] = useState<any>(null);

  useEffect(() => {
    const fetchData = async () => {
        let data = await fetchLegalComplianceInformation(language);
        if(data){
            setContent(data?.attributes?.Sitemap);
            setSeo(data?.attributes?.SitemapSEO || null);
            setGa(data?.attributes?.SitemapGA || null);
          }
        setLoading(false);
    };
    fetchData();
  }, [language]);

  const handleContent = (items: any) => {
    return Array.isArray(items) && items.map((item,index) => (
        <>
        <h4 className='font-medium mb-2'>{item?.CategoryTitle}</h4>
        <p className="barlow-font mb-4"></p>
        <div className='row pb-5 mw-1070'>
            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{item?.Content}</ReactMarkdown>
        </div>
        </>
    ));
  }

  if (loading) {
    return (<>
        <div id="loader">
            <div className="spinner-border"></div>
        </div>
    </>
    );
  }

  return (
    <>
    <RenderSnA seo={seo} ga={ga} />
    <section id="main-content">
        <div className="container-fluid sitemap"  style={{maxWidth:"1340px"}}>
            <h1 className="text-center spacer font-medium">{content?.Title}</h1>
            {handleContent(content?.Category)}
        </div>
    </section>
    </>
  );
};

export default Sitemap;